const LABEL_REQUEST_ID = 'x-subito-req-id';
function getAsyncHooks() {
    try {
        if (isServer()) {
            // eslint-disable-next-line @typescript-eslint/no-require-imports
            return require('async_hooks');
        }
    }
    catch (e) {
        console.log(e);
    }
}
/**
 * exported for test purposes
 */
const isServer = function () {
    return typeof window === 'undefined';
};
/**
 * exported for test purposes
 */
function getContext() {
    if (!context) {
        const asyncHooks = getAsyncHooks();
        if (asyncHooks) {
            context = new asyncHooks.AsyncLocalStorage();
        }
    }
    return context;
}
let context;
function getRequestId() {
    return getContext()?.getStore();
}
/**
 * It accepts as parameter a function and returns a new function
 * which it wraps the one passed as argument.
 *
 * If exists the reqId and the context we add the function call in context.run
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const applyContextToFunc = function (fn) {
    return async ({ req, ...others }, ...othersArgs) => {
        const reqId = req?.headers[LABEL_REQUEST_ID]?.toString() ||
            req?.headers[LABEL_REQUEST_ID.toLowerCase()]?.toString();
        const argsCallback = [{ req, ...others }, ...othersArgs];
        const context = getContext();
        if (context && reqId) {
            let response;
            await context.run(reqId, async () => {
                response = await fn(...argsCallback);
            });
            return response;
        }
        else {
            return await fn(...argsCallback);
        }
    };
};

export { LABEL_REQUEST_ID, applyContextToFunc, getContext, getRequestId, isServer };
//# sourceMappingURL=index.js.map
